/* global tinymce */
const columnsConfig = {
  title: "Columns",
  body: {
    type: "panel",
    items: [
      {
        type: "listbox",
        name: "columnCount",
        label: "Select number of columns",
        disabled: false,
        items: [
          {
            text: "2",
            value: "2",
          },
        ],
      },
      {
        type: "input",
        name: "desktopGap",
        label: "Desktop spacing",
        placeholder: "0",
        default: "0",
      },
      {
        type: "input",
        name: "mobileGap",
        label: "Mobile spacing",
        placeholder: "0",
        default: "0",
      },
    ],
  },
  initialData: {
    columnCount: "2",
    desktopGap: "0",
    mobileGap: "0",
  },
  buttons: [
    {
      type: "cancel",
      name: "closeButton",
      text: "Cancel",
    },
    {
      type: "submit",
      name: "submitButton",
      text: "Insert",
      primary: true,
    },
  ],
  onSubmit: function (api) {
    const { columnCount, desktopGap, mobileGap } = api.getData();

    tinymce.activeEditor.execCommand(
      "mceInsertContent",
      false,
      `<div class="columns dash-highlight" style="--mobile-gap: ${mobileGap}px; --desktop-gap: ${desktopGap}px;">
        ${Array.from({ length: parseInt(columnCount) }, () => `<div class="column"><p></p></div>`).join("")}
        </div>`,
    );
    api.close();
  },
};

export { columnsConfig };
